import FeedNoItemSvg from "@/assets/svg/feed-no-item.svg?react";

const ArticlesContentEmptyState = (props: { title: string; body: string }) => {
  return (
    <div className="flex flex-col items-center gap-8 mx-auto mt-20 pb-4">
      <FeedNoItemSvg />
      <div className="flex flex-col gap-2 text-center">
        <h4 className="text-2xl font-serif">{props.title}</h4>
        <p className="text-slate-600 text-sm">{props.body}</p>
      </div>
    </div>
  );
};

export default ArticlesContentEmptyState;
